import { forwardRef, HTMLAttributes, useCallback } from "react";
import { FormatDateOptions, useIntl } from "react-intl";
import { AnyPeriod, castPeriod, classNames, Period } from "@ct-react/core";
import { booking, form } from "../../../i18n/sharable-defs";
import SpriteIcon from "../../medias/sprite-icon";
import "./period.scss";

type Props = HTMLAttributes<HTMLDivElement> & { mode?: "theft", value?: AnyPeriod };

const PeriodResumeInput = forwardRef<HTMLDivElement, Props>(({ className, mode, value, ...props }, forwardedRef) => {

  const intl = useIntl();

  const format = useCallback((date: keyof Period<any>, opt?: FormatDateOptions): string => {
    if (!value) return "";
    const casted = castPeriod(value);
    return intl.formatDate(casted[date].toDate(), opt);
  }, [ value, intl ]);

  const wrapperClasses = classNames("period-input", mode, className);

  if (mode === "theft")
    return (
      <div ref={forwardedRef}
           className={wrapperClasses}
           {...props}>
        <div className="date">
          <span className="label">{intl.formatMessage(booking.checkIn)}</span>
          <span className="day">{format("start", { day: "2-digit" })}</span>
          <span>{format("start", { month: "short", year: "numeric" })}</span>
        </div>
        <SpriteIcon hash="booking.calendar" className="i-icon" width={32} />
        <div className="date">
          <span className="label">{intl.formatMessage(booking.checkOut)}</span>
          <span className="day">{format("end", { day: "2-digit" })}</span>
          <span>{format("end", { month: "short", year: "numeric" })}</span>
        </div>
      </div>);

  return (
    <div ref={forwardedRef}
         className={wrapperClasses}
         {...props}>
      <div className="fi-group">
        <SpriteIcon hash="booking.calendar" className="i-icon" width={22} />
        <label htmlFor="check-in">{intl.formatMessage(booking.checkIn)}</label>
        <input type="text" id="check-in"
               placeholder={intl.formatMessage(form.datePlaceholder)} readOnly
               value={format("start", { year: "numeric", month: "2-digit", day: "2-digit" })} />
      </div>
      <div className="fi-group">
        <SpriteIcon hash="booking.calendar" className="i-icon" width={22} />
        <label htmlFor="check-out">{intl.formatMessage(booking.checkOut)}</label>
        <input type="text" id="check-out"
               placeholder={intl.formatMessage(form.datePlaceholder)} readOnly
               value={format("end", { year: "numeric", month: "2-digit", day: "2-digit" })} />
      </div>
    </div>);

});

export default PeriodResumeInput;
